import { EvokeDerivedState } from "react-evoke";
import { AppState } from "../typings/AppState";
import { AppDerivedState } from "../typings/AppDerivedState";
//import { object } from "yup";

export const derivedState: EvokeDerivedState<AppState, AppDerivedState> = {
  userList: (getState) => {
    return Object.values(getState("users"));
  },
  userPosList: (getState) => {
    return Object.values(getState("posUsers"));
  },
  itemsList: (getState) => {
    return Object.values(getState("itemsList"));
  },
  terminalsList: (getState) => {
    return Object.values(getState("terminals"));
  },
  departmentList: (getState) => {
    return Object.values(getState("departments"));
  },
  loggedPosUserList: (getState) => {
    return Object.values(getState("loggedPosUsers"));
  },
  creditCustomersList: (getState) => {
    return Object.values(getState("creditCustomers"));
  },
  eodList: (getState) => {
    return Object.values(getState("eods"));
  },
  posConfigurationList: (getState) => {
    return Object.values(getState("posConfigurations"));
  },
  storeConfigurationList: (getState) => {
    return Object.values(getState("storeConfigurations"));
  },
  divisionList: (getState) => {
    return Object.values(getState("division"));
  },
  companyDetailsList: (getState) => {
    return Object.values(getState("companyDetails"));
  },
  voucherList: (getState) => {
    return Object.values(getState("vouchers"));
  },
  currencyList: (getState) => {
    return Object.values(getState("currency"));
  },
  resyncConfTablesList: (getState) => {
    return Object.values(getState("configurations"));
  },
};
